import React from "react";
import {
  Card,
  Form,
  Input,
  DatePicker,
  Select,
  Button,
  Typography,
} from "antd";
import {
  CalendarDays,
  Users,
  Phone,
  Mail,
  User,
  CircleCheck,
} from "lucide-react";
import "../componentsStyle.scss";
import { sendBookingToWhatsApp } from "../../helpers/Helper";

const { Title } = Typography;
const { TextArea } = Input;

export const BookForm = ({ price, packageTitle }) => {
  const [form] = Form.useForm();

  const onFinish = (values) => {
    sendBookingToWhatsApp(values, packageTitle);
  };

  return (
    <Card className="booking-card" bordered={false}>
      {/* HEADER */}
      <div className="booking-card__header">
        <Title level={3}>Book This Tour</Title>
      </div>

      {/* PRICE */}
      <div className="booking-card__price">
        <h2>€{price}</h2>&nbsp;
        <span>/ Person</span>
      </div>

      {/* FORM */}
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        className="booking-form"
      >
        {/* DATE */}
        <Form.Item
          label="Select Date"
          name="date"
          rules={[{ required: true, message: "Please select a date" }]}
        >
          <DatePicker
            className="custom-input"
            suffixIcon={<CalendarDays size={16} />}
            format="DD MMM YYYY"
          />
        </Form.Item>

        {/* GUESTS */}
        <Form.Item
          label="Guests"
          name="guests"
          rules={[{ required: true, message: "Please select guests" }]}
        >
          <Select
            className="custom-input"
            placeholder="Max 8 people"
            suffixIcon={<Users size={16} />}
            options={[
              { value: 1, label: "1 Guest" },
              { value: 2, label: "2 Guests" },
              { value: 3, label: "3 Guests" },
              { value: 4, label: "4 Guests" },
              { value: 5, label: "5 Guests" },
              { value: 6, label: "6 Guests" },
              { value: 7, label: "7 Guests" },
              { value: 8, label: "8 Guests" },
            ]}
          />
        </Form.Item>

        {/* FULL NAME */}
        <Form.Item
          label="Full Name"
          name="fullName"
          rules={[{ required: true, message: "Please enter your name" }]}
        >
          <Input
            className="custom-input"
            placeholder="John Doe"
            prefix={<User size={16} />}
          />
        </Form.Item>

        {/* PHONE */}
        <Form.Item
          label="Phone Number"
          name="phone"
          rules={[{ required: true, message: "Please enter phone number" }]}
        >
          <Input
            className="custom-input"
            placeholder="+355..."
            prefix={<Phone size={16} />}
          />
        </Form.Item>

        {/* EMAIL */}
        <Form.Item
          label="Email Address"
          name="email"
          rules={[
            { required: true, message: "Please enter email" },
            { type: "email", message: "Invalid email" },
          ]}
        >
          <Input
            className="custom-input"
            placeholder="example@email.com"
            prefix={<Mail size={16} />}
          />
        </Form.Item>

        {/* SPECIAL REQUEST */}
        <Form.Item label="Special Request (Optional)" name="specialRequest">
          <TextArea
            rows={4}
            className="custom-textarea"
            placeholder="Any allergies, food preferences, special requests..."
          />
        </Form.Item>

        {/* BUTTON */}
        <Button type="primary" htmlType="submit" className="booking-btn" block>
          Book Now
        </Button>
      </Form>

      {/* INFO */}
      <div className="booking-card__info">
        <div className="info-item">
          <CircleCheck size={18} />
          <span>
            You will receive confirmation in WhatsApp with full details.
          </span>
        </div>

        <div className="info-item">
          <CircleCheck size={18} />
          <span>Free cancellation</span>
        </div>

        <div className="info-item">
          <CircleCheck size={18} />
          <span>Reserve now & pay later</span>
        </div>
      </div>
    </Card>
  );
};
